import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { userLogin } from '../../store/auth/actions';
import { formatPhoneNumberAsYouType } from "../../helpers/formatterHelper";
import { checkValidIpAddress } from '../../store/companyShopMonitorIPs/actions';
import { showLoading, hideLoading } from '../../store/loading-reducer';
import { AlertMessageModal } from "../../components/AlertMessage/AlertMessageModal";
import { bindActionCreators } from "@reduxjs/toolkit";
import { ShopMonitorNumber } from "../../helpers/constants";
import { getCompanies } from '../../store/employee/actions';
export default function ShopMonitors() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const [isAlertVisible, setIsAlertVisible] = useState(false);
    const [alertConfig, setAlertConfig] = useState({
        id: null,
        message: '',
        title: '',
        description: ''
    });
    const login = bindActionCreators(userLogin, dispatch);

    useEffect(() => {
        const authenticateAndCheckIp = async () => {
            dispatch(showLoading());

            try {
                const phoneNumber = formatPhoneNumberAsYouType(ShopMonitorNumber);

                const loginData = { PhoneNumber: phoneNumber, VerificationCode: "" };

                const result = await login({ data: loginData }).unwrap();

                if (result?.data?.success) {
                    const res = await dispatch(getCompanies()).unwrap();
                    if (res && res.success) {
                        let storedCompanyId = localStorage.getItem('monitor_mode_company');
                        if (!storedCompanyId || storedCompanyId === '0' || storedCompanyId === 0) {
                            const defaultCompanyId = (res.data && res.data.length > 0) ? res.data[0].id : 0;
                            localStorage.setItem('monitor_mode_company', defaultCompanyId);
                        }
                    }
                    console.log("Auto login successful for Shop Monitor.");
                } else {
                    console.warn("Login failed:", result?.data?.message);
                    setAlertConfig({
                        id: null,
                        message: result?.data?.message || 'Login failed.',
                        title: "LOGIN ERROR",
                        description: ""
                    });
                    setIsAlertVisible(true);
                    return;
                }

                const response = await dispatch(checkValidIpAddress(0)).unwrap();

                if (response?.success && response?.data) {
                    navigate('/shopmonitors/bonuslevels');
                } else {
                    setAlertConfig({
                        message: response?.message || 'Invalid IP',
                        title: "ALERT MESSAGE",
                        description: ""
                    });
                    setIsAlertVisible(true);
                }
            } catch (error) {
                console.error("Error during login or IP check:", error);
                setAlertConfig({
                    message: error?.message || 'Unknown error occurred.',
                    title: "ERROR",
                    description: ""
                });
                setIsAlertVisible(true);
            } finally {
                dispatch(hideLoading());
            }
        };

        authenticateAndCheckIp();

    }, [location.state?.refresh]);

    return (
        <div className="contest-wrap">
            {isAlertVisible && (
                <AlertMessageModal
                    show={isAlertVisible}
                    onClose={() => { setIsAlertVisible(false); navigate('/') }}
                    model={alertConfig}
                />
            )}
        </div>
    );
}
